import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { UserType } from "../../types/User";
import { get } from "../../utils/axios-config";
import { USERS, USERS_BY_BI, USERS_BY_NUIT } from "../../utils/constants";

export const getUsers = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.UserId ? { UserId: data.UserId } : {}),
        ...(data?.Role ? { Role: data.Role } : {}),
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),
    });
    const url = `${USERS}?${queryParams.toString()}`;
    return await get<PagedResultsType<UserType>>(url)
};

export const getUserById = async (id: string) => {
    const url = `${USERS}/${id}`;
    return await get<UserType>(url)
};
export const getUserByNuit = async (nuit: string) => {
    const url = `${USERS_BY_NUIT}/${nuit}`;
    return await get<UserType>(url)
};
export const getUserByBI = async (bi: string) => {
    const url = `${USERS_BY_BI}/${bi}`;
    return await get<UserType>(url)
};